import * as v from "valibot";
import { fromPageParam } from "@/shared/model/detail-search-params";

export const searchParams = v.object({
  lotId: v.optional(v.string()),
  tab: v.optional(v.string()),
  from: fromPageParam,
});
